import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { EventRow } from "web_myplann/Activities/Components/EventRow";
import { useFormatDateAndTimes } from "web_myplann/Activities/Hooks/useActivitiesFormatDateAndTimes";
import {
	type ActivityListItemResponseDTO,
	TimelineItemCategoryEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";
import { useFormatUserWithType } from "web_myplann/Shared/Hooks/useFormatUserWithType";
import { mapActivityRowLines } from "web_myplann/Shared/Utils/mapActivityRowLines";

type Props = {
	data: ActivityListItemResponseDTO;
	showDivider: boolean;
	showPerson?: boolean;
};

export const ActivityListRow: FC<Props> = ({
	data,
	showDivider,
	showPerson = false,
}) => {
	const { t } = useResource();
	const navigate = useNavigate();
	const formatDateAndTimes = useFormatDateAndTimes();
	const formatUserWithType = useFormatUserWithType();

	const lines = mapActivityRowLines({
		typeLabel: t(Resources.Activity.List.ActivityType[data.type]),
		dateLabel: formatDateAndTimes(data.date, data.timeFrom, data.timeTo),
		title: data.title,
		place: data.place,
		person: showPerson ? formatUserWithType(data.author) : undefined,
	});

	return (
		<EventRow
			{...lines}
			category={TimelineItemCategoryEnum.Activity}
			showDivider={showDivider}
			onClick={() => {
				if (data.id != null) {
					navigate(AppRouting.MyPlann.ActivityDetail.path(String(data.id)));
				}
			}}
		/>
	);
};
